import { useState } from "react";
import { Link } from "react-router-dom";
import { post } from "../../utils/service";
import AuthShell, { GlassInputWrapper, authButton, authInput } from "@/components/auth/AuthShell";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err: any) {
      setError(err?.response?.data?.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title={sent ? "Check your email" : "Forgot your password?"}
      subtitle={sent
        ? `If an account exists for ${email}, we've sent a link to choose a new password. It expires in 60 minutes.`
        : "Enter your email and we'll send you a link to choose a new password. You can also use it to set a password if you've only signed in with Google or Microsoft."}
    >
      {sent ? (
        <Link to="/login" className={`${authButton} block text-center`}>Back to sign in</Link>
      ) : (
        <form className="space-y-5" onSubmit={submit}>
          <div>
            <label className="text-xs font-medium text-gray-700">Email Address</label>
            <GlassInputWrapper>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Enter your email address" className={authInput} disabled={loading} />
            </GlassInputWrapper>
          </div>
          {error && <p className="text-red-500 text-xs">{error}</p>}
          <button type="submit" disabled={loading || !email} className={authButton}>{loading ? "Sending..." : "Send link"}</button>
          <p className="text-center text-xs text-gray-600"><Link to="/login" className="text-[#ff6d27] hover:underline">Back to sign in</Link></p>
        </form>
      )}
    </AuthShell>
  );
}
